export default __webpack_public_path__ + "static/media/logoSample4.304df60f.png";